import { render, staticRenderFns } from "./SROForm.vue?vue&type=template&id=8566223e&scoped=true&"
import script from "./SROForm.vue?vue&type=script&lang=js&"
export * from "./SROForm.vue?vue&type=script&lang=js&"
import style0 from "./SROForm.vue?vue&type=style&index=0&id=8566223e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8566223e",
  null
  
)

export default component.exports